import Cookies from 'js-cookie';
import {countries} from '@wr/plutonium/lib';
import {pushAnalyticsEvent} from './index';

export const setPageLoadEvent = info => {
    const {
        tracking,
        customer,
        platformData,
        isSavedCardsPage,
        provider,
        pageName,
        calculation
    } = info;

    const destinationCountryIso =
        calculation?.receiveCountry?.code?.toLowerCase() ||
        Cookies.get('selectTo')?.toLowerCase() ||
        '';
    const destinationCountry = countries.getCountryName(destinationCountryIso)?.toLowerCase() ?? '';
    const numTransfers = Cookies.get('TransactionsCount') ?? '';
    const senderCountryIso = customer?.countryCode ?? '';
    const customerId = customer?.id ?? '';

    const dataLayer = {
        event: 'page loaded',
        pageType: 'transfer process',
        pageLanguage: tracking?.gaLanguage ?? '',
        senderCountry: tracking?.gaSenderCountry?.toLowerCase() ?? '',
        senderCountryIso: senderCountryIso.toUpperCase(),
        destinationCountryIso: destinationCountryIso.toUpperCase(),
        customerId: customerId ? `WR${customerId}` : '',
        requestDevice: platformData?.platform ?? '',
        visitorStatus: customer?.id ? 'logged in' : 'logged out',
        countryCorridorIso: `${senderCountryIso.toUpperCase()}-${destinationCountryIso.toUpperCase()}`,
        numTransfers,
        destinationCountry,
        pageName
    };

    if (!pageName) {
        if (isSavedCardsPage) {
            dataLayer.pageName = `/transfer/payment/card-payment-saved-cards-${provider}`;
        } else {
            dataLayer.pageName = `/transfer/payment/card-payment-details-${provider}`;
        }
    }

    pushAnalyticsEvent(dataLayer);
};
